import { Upload, DollarSign, Target, Sparkles } from "lucide-react";

const BULLETS = [
  { icon: Upload,      text: "Parse your resume with AI in seconds" },
  { icon: DollarSign,  text: "Benchmark your salary vs the market" },
  { icon: Target,      text: "Map your career roadmap 5 years out" },
  { icon: Sparkles,    text: "Get proactive AI insights every morning" },
];

export default function WelcomeStep() {
  return (
    <div className="space-y-4">
      <ul className="space-y-3">
        {BULLETS.map((it) => (
          <li key={it.text} className="flex items-center gap-3 text-sm">
            <div className="w-8 h-8 rounded-lg bg-primary/10 text-primary flex items-center justify-center">
              <it.icon size={14} />
            </div>
            <span className="text-foreground">{it.text}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
